<template>
  <b-table
    show-empty
    head-variant="dark"
    empty-text="No Claims available."
    stacked="md"
    bordered
    striped
    small
    sticky-header="200px"
    :items="claimsummary"
    :fields="fieldsClaim"
    style="font-size: 12px"
  >
    <!-- <template v-slot:thead-top="">
        <b-tr>
            <b-th colspan="2"><span class="sr-only">SL and District Name</span></b-th>
            <b-th variant="secondary" colspan="5">Pending Claims</b-th>
        </b-tr>
        </template> -->

    <template v-slot:cell(SL)="row">
      {{ row.index + 1 }}
    </template>

    <template v-slot:cell(Accounts)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Accounts')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Accounts }}</b-button
      >
    </template>

    <template v-slot:cell(Auditor)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Auditor')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Auditor }}</b-button
      >
    </template>
    
    <!-- new Dgm start  -->
    <template v-slot:cell(DGM)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'DGM')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.DGM }}</b-button
      >
    </template>
    <!-- new Dgm end -->

    <template v-slot:cell(GM)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'GM')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.GM }}</b-button
      >
    </template>

    <template v-slot:cell(MD)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'MD')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.MD }}</b-button
      >
    </template>

    <template v-slot:cell(ToBePaid)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'ToBePaid')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.ToBePaid }}</b-button
      >
    </template>

    <template v-slot:cell(Paid)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Paid')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Paid }}</b-button
      >
    </template>

    <template v-slot:cell(Rejected)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Rejected')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Rejected }}</b-button
      >
    </template>
    <template v-slot:cell(Applicant)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Applicant')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Applicant }}</b-button
      >
    </template>
  </b-table>
</template>
<script>
import apis from "@/apis";
import { normalizeResponseArray } from "@/utils/responseNormalizer";
export default {
  mounted() {
    this.loadDistrictMaster().then(() => {
      this.getClaimSummary('0');
    });
    this.$root.$on('component1', (loanType) => {
            // your code goes here
            this.getClaimSummary(loanType.temploanType);
        })
  },
  methods: {
    normalizeName(value) {
      return String(value || "").trim().toLowerCase();
    },
    getEmptySummaryRow(district) {
      return {
        DistrictID: district && district.DistrictID || district && district.DistID || "",
        DistrictName: district && district.DistrictName || district && district.DistName || "",
        Accounts: 0,
        Auditor: 0,
        DGM: 0,
        GM: 0,
        MD: 0,
        ToBePaid: 0,
        Paid: 0,
        Rejected: 0,
        Applicant: 0,
        Total: 0
      };
    },
    loadDistrictMaster() {
      if (Array.isArray(this.districtMaster) && this.districtMaster.length > 0) {
        return Promise.resolve(this.districtMaster);
      }

      return apis.getDistricts("BB62F7B0-748D-4E64-AD4F-8EF691431FA1")
        .then((response) => {
          if (response && response.status == 200) {
            this.districtMaster = normalizeResponseArray(response).filter((district) => {
              const name = this.normalizeName(district.DistName || district.DistrictName);
              const id = String(district.DistID || district.DistrictID || "").trim();
              return name !== "all" && id !== "00000000-0000-0000-0000-000000000000";
            });
          }
          return this.districtMaster;
        })
        .catch(() => this.districtMaster);
    },
    withAllDistrictRows(rows) {
      const sourceRows = normalizeResponseArray(rows);
      if (!Array.isArray(this.districtMaster) || this.districtMaster.length === 0) {
        return sourceRows;
      }

      const allDistrictId = "00000000-0000-0000-0000-000000000000";
      const existingById = {};
      const existingByName = {};
      let totalRow = null;

      sourceRows.forEach((row) => {
        const districtId = String(row.DistrictID || row.DistrictId || row.DistID || "").trim();
        const districtName = this.normalizeName(row.DistrictName || row.District || row.DistName);
        if (districtName === "total" || districtId === allDistrictId) {
          totalRow = row;
          return;
        }
        if (districtId) existingById[districtId] = row;
        if (districtName) existingByName[districtName] = row;
      });

      const districtRows = this.districtMaster.map((district) => {
        const emptyRow = this.getEmptySummaryRow(district);
        const districtId = String(emptyRow.DistrictID || "").trim();
        const districtName = this.normalizeName(emptyRow.DistrictName);
        return Object.assign(
          {},
          emptyRow,
          existingById[districtId] || existingByName[districtName] || {}
        );
      });

      if (!totalRow) {
        totalRow = Object.assign(this.getEmptySummaryRow({
          DistrictID: allDistrictId,
          DistrictName: "TOTAL"
        }), {
          DistrictName: "TOTAL"
        });
      }

      return districtRows.concat([totalRow]);
    },
    getClaimSummary(loanType) {
      this.claimLoanType = Number(loanType) || 0;
      let promise = apis.ReadClaimDashBoard(loanType);

      promise
        .then((response) => {
          if (response.status == 401) {
            this.$store.dispatch("logout");
            this.$router.replace("/");
            return;
          }
          if (response.status == 200) {
            this.claimsummary = this.withAllDistrictRows(response);
            if (this.RoleID == 4) {
            let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
            this.PendingCountLOI = ttl[0].Accounts;
            this.PendingLabel = "Pending MD Approval";
            }
            // new Dgm start
            else if (this.RoleID == 5) {
            let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
            this.PendingCountLOI = ttl[0].DGM;
            this.PendingLabel = "Pending DGM Approval";
            }
            // new Dgm end

            else if (this.RoleID == 5) {
            let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
            this.PendingCountLOI = ttl[0].GM;
            this.PendingLabel = "Pending GM Approval";
            }else if (this.RoleID == 3) {
              let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
              this.PendingCountLOI = ttl[0].MD;
              this.PendingLabel = "Pending MD Approval";
            }
            let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
            if (ttl.length > 0) {
              this.$emit("ttl", ttl[0].Accounts, ttl[0].DGM, ttl[0].GM, ttl[0].MD);
            }
          }
        })
        .catch((err) => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
        var promise1;
      if (this.RoleID !== 3 && this.RoleID != 4 && this.RoleID != 5) {
        //promise1 = apis.getApplicationSummary(this.selectedDistrict);
      } else if (this.RoleID == 3 || this.RoleID == 4 || this.RoleID == 5) {
        //promise1 = apis.getApplicationSummaryMD(this.loanType);
      } else {
        return;
      }
    },
    updateClaimCounts(loanType) {
      const selectedLoanType = Number(loanType || 0);
      if (!selectedLoanType) {
        return;
      }

      const allDistrictId = "00000000-0000-0000-0000-000000000000";
      const statusOwners = ["Accounts", "Auditor", "DGM", "GM", "MD", "ToBePaid", "Paid", "Rejected", "Applicant"];
      const loanTypes = [selectedLoanType];
      const baseRequest = {
        DistrictID: allDistrictId,
        BankID: allDistrictId,
        ClaimStatus: 0,
        ClaimPaidStatus: 0,
        LoanApplicationNo: null,
        LOINumber: null,
        UserLoginID: null,
        RecoStatus: 0,
        ClaimStartDate: null,
        ClaimEndDate: null,
        LoanType: selectedLoanType
      };

      Promise.all(statusOwners.map((statusOwner) => {
        return Promise.all(loanTypes.map((currentLoanType) => {
          return apis.ReadClaimEMIForApproval(Object.assign({}, baseRequest, {
            LoanType: currentLoanType,
            ClaimStatus: statusOwner === "ToBePaid" ? 4 : 0,
            StatusOwner: statusOwner
          })).then((response) => {
            if (!response || response.status !== 200) {
              return [];
            }
            return normalizeResponseArray(response).filter((claim) => {
              const responseLoanType = Number(claim.LoanType || claim.LoanTypeID || claim.SchemeTypeID || 0);
              return !responseLoanType || responseLoanType === currentLoanType;
            });
          }).catch(() => []);
        })).then((claimGroups) => ({
          statusOwner,
          claims: this.uniqueClaimRows([].concat.apply([], claimGroups))
        }));
      })).then((resultSets) => {
        if (this.claimLoanType !== selectedLoanType) {
          return;
        }

        const normalizeName = (value) => String(value || "").trim().toLowerCase();

        this.claimsummary = (this.claimsummary || []).map((summary) => {
          const districtId = String(summary.DistrictID || "").trim();
          const districtName = normalizeName(summary.DistrictName);
          const isTotal = districtName === "total" || districtId === allDistrictId;
          const counts = {};

          resultSets.forEach((result) => {
            counts[result.statusOwner] = isTotal
              ? result.claims.length
              : result.claims.filter((claim) => {
                  const claimDistrictId = String(claim.DistrictID || claim.DistrictId || "").trim();
                  const claimDistrictName = normalizeName(claim.DistrictName || claim.District);
                  return (districtId && claimDistrictId === districtId) ||
                    (!claimDistrictId && districtName && claimDistrictName === districtName);
                }).length;
          });

          counts.Total = Object.keys(counts).reduce((total, statusOwner) => {
            return total + Number(counts[statusOwner] || 0);
          }, 0);

          return Object.assign({}, summary, counts);
        });

        const total = (this.claimsummary || []).find((summary) => {
          return normalizeName(summary.DistrictName) === "total" || String(summary.DistrictID || "") === allDistrictId;
        });
        if (total) {
          this.$emit("ttl", total.Accounts || 0, total.DGM || 0, total.GM || 0, total.MD || 0);
        }
      }).catch(() => {});
    },
    uniqueClaimRows(rows) {
      // Dedupe only exact duplicate rows; each ClaimEMIID+EMISchedule pair is a
      // distinct EMI installment and must be counted separately (not collapsed
      // down to one row per claim).
      const seen = new Set();
      return (rows || []).filter((claim, index) => {
        const claimId = claim && (claim.ClaimEMIID || claim.ClaimID || claim.ClaimId);
        const emiId = claim && (claim.EMISheduledID || claim.EMIScheduleID || claim.EMIScheduledID || claim.EmiScheduleID);
        const key = claimId
          ? String(claimId).trim().toLowerCase() + "|" + String(emiId || "").trim().toLowerCase()
          : "row-" + index;
        if (seen.has(key)) {
          return false;
        }
        seen.add(key);
        return true;
      });
    },
    viewClaims(item, sts) {
      this.$store.dispatch("setDistrict", item.DistrictID);
      this.$store.dispatch("setAppStatus", sts === "ToBePaid" ? 4 : 0);
      this.$store.dispatch("setStatusOwner", sts);
      this.$store.dispatch("setLoanType", this.claimLoanType);
      this.$router.push("/approveclaims");
    }
  },
  data() {
    return {
      claimsummary: [],
      districtMaster: [],
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      id:1,
      claimLoanType: 1,
      fieldsClaim: [
        { key: "SL", label: "SL" },
        { key: "DistrictName", label: "District Name" },
        { key: "Accounts", label: "Accounts" },
        { key: "Auditor", label: "Auditor" },
        
        // new Dgm start 
        { key: "DGM", label: "DGM" },
        // new Dgm end

        { key: "GM", label: "GM" },
        { key: "MD", label: "MD" },
        { key: "ToBePaid", label: "To Be Paid" },
        { key: "Paid", label: "Paid" },
        { key: "Rejected", label: "Rejected" },
        { key: "Applicant", label: "Applicant" },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Admin/ClaimsTable.vue